import { PRIVACY_SETTINGS_PATH } from './routePaths';

export const routes = {
  [PRIVACY_SETTINGS_PATH]: {
    path: PRIVACY_SETTINGS_PATH,
    displayName: 'Privacy Settings',
    breadcrumbBackUrl: '/',
    description: 'Manage Privacy Settings'
  }
};

export default routes;
